'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _naturalSortBy = require('./services/naturalSortBy.service');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_naturalSortBy).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/natural-sort-by/lib/index.js
// module id = 1431
// module chunks = 1